module.exports = "<img [src]=\"photoUrl\">\r\n"